
<div [class]="stateClass"><i class="ml-1 mr-1 fas {{stateIcon}}"></i><span class="text-uppercase">{{stateText|translate}}</span><span class="steps" *ngIf="progress?.max &amp;&amp; !progress?.bar">{{(progress!.current ?? 0)|bytes:0:'items'}} / {{progress!.max!|bytes:0:'items'}}</span>
  <div class="bar" style.width="{{100 - progressPercent}}%"></div>
</div>